import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { IProjectData } from "hooks/api/GQL/project/useProjectData.models";
import { ProjectStatus } from "utils/constants/project.constants";
import {
  checkHasRegulatoryReviewTemplate,
  checkHasRelianceTemplate,
} from "utils/helpers/project/project";
import {
  getProjectStatuses,
  getRelianceProjectStatuses,
} from "./useProjectStatusOptions.utils";

export type TProjectStatusOption = {
  id: ProjectStatus;
  label: string;
  disabled?: boolean;
  adornment?: ReactNode | null;
};

const useProjectStatusOptions = (
  project: IProjectData | null | undefined,
): TProjectStatusOption[] => {
  const { t } = useTranslation("projects");

  if (!project) {
    return [];
  }

  if (checkHasRelianceTemplate(project)) {
    return getRelianceProjectStatuses(project, t);
  }

  if (checkHasRegulatoryReviewTemplate(project)) {
    return getProjectStatuses(project, t);
  }

  return [];
};

export default useProjectStatusOptions;
